/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import fondo_portada_home from '../../../Recursos/fondo_portada.png'
import Propuesta_Valor_Portada_Home from "./SubComponentes/Propuesta_Valor_Portada_Home";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import fondo from '../../../Recursos/video_home.mp4'

const Portada_Home = () => {
    const {masSM, sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}
        >

            <video width={'100%'} height={sCell ? 550 : 720}
                   style={{
                       objectFit: 'cover',
                       zIndex: 1
                   }}
                   id="background-video" autoPlay loop muted poster={fondo_portada_home}>
                <source src={fondo} type="video/mp4"/>
            </video>

            <Grid2 container size={12}
                   sx={{
                       display: "flex",
                       alignItems: "center",
                       justifyContent: "center",
                       backgroundImage: `linear-gradient(70deg, #000 20%, transparent 80%)`,
                       backgroundSize: "cover",
                       backgroundPosition: "center",
                       overflowX: 'hidden',
                       marginTop: sCell ? -69 : -90,
                       height: sCell ? 550 : 720,
                       overflowY: 'hidden',
                       zIndex: 2
                   }}
            >
                <Grid2 container size={12} justifyContent={'center'}
                       sx={{maxWidth: "1400px", px: 3}}>

                    <Grid2 container size={{xs: 12, sm: 12, md: 11}}>

                        <Grid2 container size={masSM ? 7 : 12}
                               sx={{pt: sCell ? 14 : 30, pb: sCell ? 6 : 30}}>
                            <Propuesta_Valor_Portada_Home/>
                        </Grid2>

                        <Grid2 container size={masSM ? 6 : 12}>

                        </Grid2>

                    </Grid2>


                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default Portada_Home